import React from 'react';
import Footer from '../components/footer';
import Header from '../components/header';
import LoginModal from '../components/loginModal';
import SignupModal from '../components/signupModal';
import SLATable from '../components/SlaTable';
import * as SetWidget from '../operationalHelper/populateWidget';

class Agreement extends React.Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    componentDidMount() {
        document.title = "SLA - Aviatrix"
        SetWidget.populateWidget()
    }

    render() {
        return (
            <React.Fragment>
                <div className="min-height-full">
                    {/* ==== Header for Page ==== */}
                    <Header parent="SLA"></Header>
                    <br />
                    <br />
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/>
                    <br className="hide-on-mobile"/> 
                    <div className="container pt-5 p-md-b-5" style={{ maxWidth: "900px" }}>
                        <h2 className="m-0 p-0 fs-8"><strong>Aviatrix Support Service Level Agreement</strong></h2>
                        <p className="p-0 fs-3 mb-4">Engagement with Aviatrix Support is via creating a  <a href="https://aviatrix.zendesk.com/hc/en-us/articles/360054841492-Aviatrix-Support-Ticket-Submission-Priority-Guidelines" target="_blank"><span className="text-danger">Support ticket</span></a> or by calling +1 (888) 311-8328 (toll free in the US only). The Support SLA is as per the following table. </p>
                            <SLATable/>
                        <div className="row">
                            <p className="fs-3 mt-5">For additional information visit <a className='text-danger' href="service-descriptions" target="_blank">
                                <strong>Service Descriptions</strong></a> +1 (888) 311-8328</p>
                        </div>
                    </div>

                    {/* ==== Login Modal ==== */}
                    <LoginModal></LoginModal>

                    {/* ==== Sign up Modal ==== */}
                    <SignupModal></SignupModal>

                    {/* ==== Footer Component ==== */}
                    <Footer></Footer>
                    <br className="hide-on-mobile"/> 
                    <br className="hide-on-mobile"/> 
                    <br className="hide-on-mobile"/> 

                </div>
            </React.Fragment >
        )
    }
}

export default Agreement

